import Styles from './HeaderMenu.module.scss';
import { DobButton, DobDropdownMenu, DobDropdownMenuItem } from '@dedalusdiit/dob-components';

export interface HeaderMenuProps {
    options: HeaderMenuOption[];
}

export type HeaderMenuOption = HeaderMenuOptionUrl | HeaderMenuOptionCallback;

interface HeaderMenuOptionBase {
    iconName?: string;
    title: string;
}

export interface HeaderMenuOptionUrl extends HeaderMenuOptionBase {
    type: 'url';
    url: URL;
}

export interface HeaderMenuOptionCallback extends HeaderMenuOptionBase {
    type: 'callback';
    onClick: () => void;
}

const HeaderMenu = (props: HeaderMenuProps): React.ReactElement => {
    const { options } = props;
    const { headerMenuItem, headerMenuItemTitle } = Styles;

    const handleClick = (option: HeaderMenuOption): void => {
        if (isUrl(option)) {
            window.open(option.url, '_blank')?.focus();
        }
        else if (isCallback(option)) {
            option.onClick();
        }
    };

    const optionElements = options.map((option) => {
        const { title, iconName } = option;

        return (
            <DobDropdownMenuItem key={title} onSelect={() => handleClick(option)}>
                <div className={headerMenuItem}>
                    <div className={headerMenuItemTitle}>{title}</div>
                    <div>
                        <span className="material-symbols-outlined">{iconName}</span>
                    </div>
                </div>
            </DobDropdownMenuItem>
        );
    });

    return (
        <DobDropdownMenu
            trigger={(
                <div>
                    <DobButton color="silent" icon="question-lg" />
                </div>
            )}
        >
            {optionElements}
        </DobDropdownMenu>
    );
};

const isUrl = (option: HeaderMenuOption): option is HeaderMenuOptionUrl => {
    return option.type === 'url';
};

const isCallback = (option: HeaderMenuOption): option is HeaderMenuOptionCallback => {
    return option.type === 'callback';
};

export default HeaderMenu;
